import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as ChevronRight } from 'assets/icons/navigation/small/chevron-right-sm.svg';
import { BreadcrumbsContainer } from './styled';

const capitalize = (s: string | undefined): string => {
  if (!s) return '';
  return s.charAt(0)?.toUpperCase() + s?.slice(1);
};

export const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const paths = location?.pathname?.split('/')?.filter(Boolean);
  const breadcrumbs = paths?.map((segment, index) => {
    const path = '/' + paths?.slice(0, index + 1).join('/');
    const isLast = index === paths?.length - 1;
    return isLast ? (
      <span key={path}>{capitalize(segment)}</span>
    ) : (
      <span key={path}>
        <Link to={path}>{capitalize(segment)}</Link>
        <ChevronRight />
      </span>
    );
  });
  return (
    <BreadcrumbsContainer>
      {paths && paths.length > 0 ? (
        <>
          <Link to={'/home'}>Home</Link>
          <ChevronRight />
          {breadcrumbs}
        </>
      ) : (
        <span>Home</span>
      )}
    </BreadcrumbsContainer>
  );
};
